module.exports = __webpack_public_path__ + "img/widgetabout-5.7282a8ef.jpg";